(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kotlin-web'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kotlin-web'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin-browser'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kotlin-browser'.");
    }
    if (typeof this['kotlin-web'] === 'undefined') {
      throw new Error("Error loading module 'kotlin-browser'. Its dependency 'kotlin-web' was not found. Please, check whether 'kotlin-web' is loaded prior to 'kotlin-browser'.");
    }
    root['kotlin-browser'] = factory(typeof this['kotlin-browser'] === 'undefined' ? {} : this['kotlin-browser'], kotlin, this['kotlin-web']);
  }
}(this, function (_, Kotlin, $module$kotlin_web) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var defineInlineFunction = Kotlin.defineInlineFunction;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var HTML_instance = null;
  var SVG_instance = null;
  function appendText($receiver, text) {
    $receiver.appendChild($receiver.ownerDocument.createTextNode(text));
    return $receiver;
  }
  var SVG_NAMESPACE;
  $$importsForInline$$['kotlin-web'] = $module$kotlin_web;
  var package$dom = _.dom || (_.dom = {});
  package$dom.appendText_pr2go1$ = appendText;
  SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  return _;
}));

//# sourceMappingURL=kotlin-browser.js.map
